import React from "react";

const Footer = () => {
  return (
    <>
      <style>{`
        .font-footer {
          background: #222;
          color: white;
          text-align: center;
          padding: 12px 20px;
          font-size: 15px;
          line-height: 1.6;
          width: 100%;
          box-sizing: border-box;
        }

        /* Tablet Responsive */
        @media (max-width: 768px) {
          .font-footer {
            font-size: 14px;
            padding: 10px 15px;
          }
        }

        /* Mobile Responsive */
        @media (max-width: 480px) {
          .font-footer {
            font-size: 12px;
            padding: 10px;
            line-height: 1.3;
          }
        }
      `}</style>

      <div className="font-footer">
        © 2026 Nano Cloud Technology, School Management System .
        All Rights Reserved.
      </div>
    </>
  );
};

export default Footer;